import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { ViewTallyTransactionsModel } from "../models/view-tally-transactions-model";

@Injectable ({
    providedIn: 'root'
})

export class ViewTallyTransactionService {
    constructor(private http: HttpClient) {}

    lFN_GetViewTallyTransactionsList(l_fromDate: string, l_toDate: string) {
        const l_params = new HttpParams().set('fromDate', l_fromDate).set('toDate', l_toDate);
        return this.http.get(`${environment.ROOT_URL}/jsyogtally/transactions`, { withCredentials: true, responseType: 'text', observe: 'response', params: l_params });
    }

    lFN_GetTallyReportData(l_fromDate: string, l_toDate: string, l_reportType: string) {
        const l_params = new HttpParams().set('fromDate', l_fromDate).set('toDate', l_toDate).set('reportType', l_reportType);
        return this.http.get(`${environment.ROOT_URL}/jsyogtally/report`, { withCredentials: true, responseType: 'text', observe: 'response', params: l_params });
    }

    lFN_VerifyTransactionsDone(l_fromDate: string, l_toDate: string) {
        return this.http.get(`${environment.ROOT_URL}/jsyogtally/transactions/fromDate/` + l_fromDate + `/toDate/` + l_toDate , { withCredentials: true, responseType: 'text', observe: 'response' });
    }

    lFN_SyncTallyTransactions(l_fromDate: string, l_toDate: string) {
        return this.http.get(`${environment.ROOT_URL}/jsyogtally/syncTransactions/fromDate/` + l_fromDate + `/toDate/` + l_toDate , { withCredentials: true, responseType: 'text', observe: 'response' });
    }

    lFN_DownloadTallyFileXML(l_fromDate: string, l_toDate: string) {
        return this.http.get(`${environment.ROOT_URL}/jsyogtally/downloadXML/fromDate/` + l_fromDate + `/toDate/` + l_toDate , { withCredentials: true, responseType: 'blob', observe: 'response' });
    }

    lFN_CheckUploadDownloadStatus(l_fromDate: string, l_toDate: string) {
        const l_params = new HttpParams().set('fromDate', l_fromDate).set('toDate', l_toDate);
        return this.http.get(`${environment.ROOT_URL}/jsyogtally/checkStatus`, { withCredentials: true, responseType: 'text', observe: 'response', params: l_params });
    }

    lFN_SyncTallyAccountsReceipts(l_fromDate: string, l_toDate: string) {
        return this.http.get(`${environment.ROOT_URL}/jsyogaccountstally/syncAccountsTransactions/fromDate/` + l_fromDate + `/toDate/` + l_toDate , { withCredentials: true, responseType: 'text', observe: 'response' });
    }

    lFN_DeleteTallyTransaction(l_tallyId: number) {
        return this.http.delete(`${environment.ROOT_URL}/jsyogaccountstally/removeTallyTransaction/tallyId/` + l_tallyId, { withCredentials: true, responseType: 'text', observe: 'response' });
    }
}